module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Wartau-6d09da7e3edd1e5520464b6f9f4cd7e1.svg";